import React from 'react';
import Tabs from '../../components/shared/Tabs';
import BtButton from '../bt-button/bt-button';
import appState from '../../state/AppStateContainer';
import { useTranslation } from 'react-i18next';
import SummationCards from '../app-project-purchase-list/SummationCards';
import styles from './project-tabs-and-actions.module.scss';

export default function ProjectTabsAndActions({ currentProject, selected, onChange, onNewEvaluation, onNewArea, step }) {
  const [t] = useTranslation('projects');
  const [tEvaluations] = useTranslation('evaluations');

  const getDBIndexFromUIIndex = (stepIndex) => {
    // Map UI tab index to step index
    let indexOfSelectedTab;
    if (stepIndex === 0 || stepIndex === 5) {
      indexOfSelectedTab = 6;
    } else {
      indexOfSelectedTab = stepIndex;
    }
    return indexOfSelectedTab;
  }

  const getUIIndexFromDBIndex = (stepIndex) => {
    // Map step index to UI tab index
    let indexOfSelectedTab;
    if (stepIndex === 0 || stepIndex === 5 || stepIndex === 6) {
      return 0;
    } else {
      indexOfSelectedTab = stepIndex;
    }
    return indexOfSelectedTab;
  }

  const areasInStep = (currentProject, step) => {
    if (step === 6) return currentProject.area;
    return currentProject.area.filter(a => (a.step || 1) == step);
  }

  const tooltip = (currentProject, step) => {
    const areas = areasInStep(currentProject, step);
    return areas.length ? `${t('singleProject.tab.tooltip.title', 'Upphandlingar:')}\n${areas.map(a => a.areaId.name).join('\n')}` : null;
  }

  const tabs = [
    // t('steps.strategy', 'Strategi'),
    `${t('steps.purchasePlan', 'Inköpsplan')} (${areasInStep(currentProject, 6).length})`,
    `${t('steps.request', 'Förfrågan')} (${areasInStep(currentProject, 1).length})`,
    `${t('steps.evaluation', 'Utvärdering')} (${areasInStep(currentProject, 2).length})`,
    `${t('steps.negotiation', 'Förhandling')} (${areasInStep(currentProject, 3).length})`,
    `${t('steps.agreement', 'Avtal')} (${areasInStep(currentProject, 4).length})`
  ]

  const tooltips= [
    // null,
    null,
    tooltip(currentProject, 1),
    tooltip(currentProject, 2),
    tooltip(currentProject, 3),
    tooltip(currentProject, 4)
  ]
  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabsRow}>
        <Tabs
          tabs={tabs}
          tooltips={tooltips}getUIIndexFromDBIndex
          selected={getUIIndexFromDBIndex(selected)}
          onChange={(x) => {
            onChange(getDBIndexFromUIIndex(x));
          }}
          className={styles.tabsStyle}
        />
        <div className={styles.tabActions}>
          <BtButton
            class="white"
            onClick={() => {
              appState.setShowMassMessagingModal(true);
            }}
          >
            {t('singleProject.button.massMessage', 'Massutskick')}
          </BtButton>
          {appState.isWriteAccessRole() &&
            <BtButton class="white" onClick={onNewEvaluation} tabIndex={0}>
              {tEvaluations('register.newEvaluation', 'Ny utvärdering')}
            </BtButton>
          }
          {appState.isWriteAccessRole() &&
            <BtButton class="primary" onClick={onNewArea}>
              {t('singleProject.button.newProcurement', 'Ny upphandling')}
            </BtButton>
          }
        </div>
      </div>
      
      {step === 6 && (
        <div className={styles.buttonsContainer}>
          <SummationCards areas={currentProject?.area || []} />
        </div>
      )}
    </div>
  );
}
